import type { EstatDocument } from '@/api/administracio';

export function substitueix(text: string, variables: Record<string, string>): string {
  return text.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (m, v: string) => variables[v] || m);
}

export function badgeEstatDocument(e: EstatDocument): string {
  if (e === 'PUBLICAT') return 'badge--ok';
  if (e === 'BLOQUEJAT') return 'badge--critic';
  if (e === 'ESBORRANY') return 'badge--avis';
  return 'badge--gray';
}

export function midaLlegible(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export type UnitatTemps = 'ara' | 'min' | 'h' | 'dies';

/** Temps transcorregut des d'una data, per mostrar «fa 6 min», «fa 2 dies»… */
export function tempsDes(
  iso: string | null | undefined,
  ara: number = Date.now(),
): { unitat: UnitatTemps; n: number } | null {
  if (!iso) return null;
  const min = Math.max(0, Math.round((ara - new Date(iso).getTime()) / 60000));
  if (min < 1) return { unitat: 'ara', n: 0 };
  if (min < 60) return { unitat: 'min', n: min };
  if (min < 1440) return { unitat: 'h', n: Math.round(min / 60) };
  return { unitat: 'dies', n: Math.round(min / 1440) };
}
